import { Subtitle2Text } from '@/utils/global-fonts';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const TabContainer = styled.div`
  display: flex;
  border-bottom: 1px solid #ccc;
`;

const Tab = styled(Link)`
  padding: 0px 15px 0px 15px;
  border: none;
  outline: none;
  background-color: transparent;
  text-decoration: none;
  border-bottom: 3px solid
    ${({ active, theme }) => (active ? theme.COLOR_PRIMARY : 'transparent')};
  cursor: ${({ active }) => (active ? 'default' : 'pointer')};
  pointer-events: ${({ active }) => (active ? 'none' : 'auto')};
`;

const Label = styled(Subtitle2Text)`
  color: ${({ active, theme }) =>
    active ? theme.COLOR_BLACK : theme.COLOR_GREY4};
`;

const TabSelectorStyle = {
  TabContainer,
  Tab,
  Label,
};

export default TabSelectorStyle;
